<section id="work" class="pb-0">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="row align-items-center mb-6" >
             <!--data-anime='{ "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'-->
          <div class="col-10">
            <span class="text-base-color fw-700 text-uppercase fs-14 ls-05px">Latest works</span>
          </div>
          <!--<div class="col-2 text-end">
            <span class="text-base-color fs-14 fw-700">02</span>
          </div>-->
          <div class="col-12 mt-5px">
            <div class="separator-line-2px w-100 d-block bg-base-color"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 filter-content">
            <ul class="portfolio-transform portfolio-wrapper grid-loading grid grid-4col xxl-grid-4col xl-grid-4col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-medium">
                <!--data-anime='{ "el": "childs", "translateY": [0, 0], "translateX": [0, 0], "opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" }'-->
              <li class="grid-sizer"></li>
              <li class="grid-item web digital branding" *ngFor="let item of portfolioItems">
                <div class="portfolio-box mousetip-wrapper">
                  <a [href]="item.image" data-group="lightbox-gallery" [title]="item.title">
                    <div class="portfolio-image overflow-hidden">
                      <img [src]="item.image" [alt]="item.title" />
                    </div>
                    <div class="caption bg-base-color border-radius-4px">
                      <span class="fs-17 text-white fw-500 lh-10 d-block">{{item.title}}</span>
                      <span class="fs-14 fw-500 text-black lh-initial">{{item.subtitle}}</span>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

